export { FinancialAnnouncementPage as default } from '@/components/pages/Ir/Library/FinancialAnnouncement'
